<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    max-width="600px"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <strong>ทีมขาย</strong>
      </v-card-title>

      <v-card-text style="max-height: 90%">
        <el-form
          :label-position="`left`"
          size="medium"
          label-width="100px"
          class="mt-3 pl-3"
        >
          <el-form-item label="ชื่อ">
            <el-col :span="19">
              <el-input v-model="form.firstname"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="นามสกุล">
            <el-col :span="19">
              <el-input v-model="form.lastname"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="เบอร์มือถือ">
            <el-col :span="19">
              <el-input v-model="form.mobile"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="รหัสผ่าน">
            <el-col :span="19">
              <el-input v-model="form.password"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="ชื่อสาขา - รหัสสาขา">
            <el-col :span="19">
              <el-input v-model="form.custom_field_1"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="ที่อยู่จัดส่ง">
            <el-col :span="19">
              <el-input v-model="form.custom_field_2"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="ชื่อเจ้าของ">
            <el-col :span="19">
              <el-input v-model="form.custom_field_3"></el-input>
            </el-col>
          </el-form-item>
        </el-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" depressed @click="close()">ปิด</v-btn>
        <v-btn color="primary" depressed @click="save()">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Service from "@/services";

export default {
  name: "sale-team-dialog",
  props: {
    showDialog: { default: false },
  },
  data() {
    return {
      loading: false,
      form: {
        firstname: "",
        lastname: "",
        mobile: "",
        custom_field_1: "",
        custom_field_2: "",
        custom_field_3: "",
        channel_id: "",
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  created() {
    //this.syncMap();
  },
  methods: {
    save() {
      let data = {
        firstname: this.form.firstname,
        lastname: this.form.lastname,
        mobile: this.form.mobile,
        password: this.form.password,
        password_confirmation: this.form.password,
      };

      this.loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)",
      });

      Service.User.permission().then((resp) => {
        Service.Auth.addUser(data).then((res) => {
          let user = {
            user_id: res.user_id,
            role_id: "sale",
            status: "active",
            login_by_mobile: "y",
            custom_field_1: this.form.custom_field_1,
            custom_field_2: this.form.custom_field_2,
            custom_field_3: this.form.custom_field_3,
            permission_json: {
              included_shops: [],
              included_enterprises: [resp.data.enterprises[0].ent_id],
            },
          };

          Service.Team.add(user).then((res) => {
            this.loading.close();
            this.close();
          });
        });
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.box-input {
  padding: 12px;
  display: block;
  border: 1px solid rgba(0, 0, 0, 0.24);
  background-color: rgba(0, 0, 0, 0.02) !important;
  width: 100%;
  margin-bottom: 20px;
  border-radius: 4px;
}
.overlay-marker {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 1;
}
.map-layout {
  margin: 0 -16px 16px !important;
}
</style>
